<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    append-to-body
  >
    <component
      :is="currentComponent"
      :modelType="modelType"
      @getParams="getParams"
      ref="componentRef"
    ></component>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
      <!-- <el-button
        type="primary"
        @click="confirm"
      >确 定</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import ModelOneDetail from './ModelOneDetail.vue'
import ModelTwoDetail from './ModelTwoDetail.vue'
import ModelThreeDetail from './ModelThreeDetail.vue'

export default {
  components: { ModelOneDetail, ModelTwoDetail, ModelThreeDetail },
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '750px'
    },
    modelType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      dialogVisible: false,
      currentComponent: ''
    }
  },
  methods: {
    getParams(params) {
      this.$emit('refresh', params)
      this.dialogVisible = false
    },
    show(componentName) {
      this.currentComponent = componentName
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.componentRef.getData()
      })
    }
  }
}
</script>

<style>
.el-dialog__header {
  background: #07203b !important;
}
.el-dialog__body {
  background: #07203b !important;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
.el-dialog__title {
  color: #fff !important;
}
.el-dialog__footer {
  background: #07203b !important;
}
</style>